import { createContext, useContext } from 'react';

/** The payload a page hands the next one — e.g. `{ vendorAccount }` to open
 *  Supplier 360 already focused on that vendor.
 *
 *  Values are `unknown` because this is a loosely-typed hand-off between pages
 *  that do not import each other: the receiver knows what it expects and must
 *  narrow. Typing it `any` would let a page read `params.vendorAccout` for ever. */
export type NavParams = Record<string, unknown>;

export interface NavState {
  navigate: (page: string, params?: NavParams) => void;
  params: NavParams;
}

/**
 * Cross-page navigation with a payload — e.g. a vendor row on Spend Cube opens
 * Supplier 360 already focused on that vendor.
 *
 * Lives in its own module (not App.jsx) so pages can import `useNav` without a
 * circular import back through the page registry.
 */
export const NavContext = createContext<NavState>({ navigate: () => {}, params: {} });

export function useNav(): NavState {
  return useContext(NavContext);
}
